const VARIANT_UPDATE_EVENT = 'variant:update';

class BoxPurchaseOption extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('product-form-component');
    this.options = this.form?.querySelector('[data-purchase-unit-options]');
    this.input = this.form?.querySelector('input[name="quantity"]');
    this.currentPrice = Number(this.dataset.basePrice || 0);
    if (!this.form || !this.options || !this.input) return;
    console.info('[Box Purchase] controller connected', {
      b2bTypeFromLocationMetafield: this.form.dataset.b2bType || '(blank)',
      form: this.form,
    });
    this.loadVariants();
    this.options.addEventListener('change', () => this.update());
    this.input.addEventListener('input', () => this.update());
    this.form.addEventListener(VARIANT_UPDATE_EVENT, this.variantUpdate);
    this.update();
    requestAnimationFrame(() => this.update());
  }

  disconnectedCallback() {
    this.form?.removeEventListener(VARIANT_UPDATE_EVENT, this.variantUpdate);
  }

  loadVariants() {
    try {
      this.variants = JSON.parse(this.form.querySelector('[data-box-variants]')?.textContent || '[]');
      const pickerVariants = JSON.parse(this.form.closest('.shopify-section')?.querySelector('variant-picker script[type="application/json"]')?.textContent || '[]');
      this.variants = this.variants.map((variant) => ({ ...variant, price: pickerVariants.find((item) => String(item.id) === String(variant.id))?.price }));
    } catch {
      this.variants = [];
    }
  }

  variantUpdate = (event) => {
    if (event.detail.resource?.price != null) this.currentPrice = Number(event.detail.resource.price);
    const source = event.detail.data.html?.querySelector('[data-box-variants]');
    if (source) {
      try {
        this.variants = JSON.parse(source.textContent || '[]');
        const pickerVariants = JSON.parse(event.detail.data.html?.querySelector('variant-picker script[type="application/json"]')?.textContent || '[]');
        this.variants = this.variants.map((variant) => ({ ...variant, price: pickerVariants.find((item) => String(item.id) === String(variant.id))?.price }));
      } catch { this.variants = []; }
    }
    this.update();
  };

  update() {
    const variantIdInput = this.form.refs?.variantId || this.form.querySelector('input[name="id"]');
    const current = this.variants.find((variant) => String(variant.id) === String(variantIdInput?.value));
    const boxOption = this.options.querySelector('[data-box-option]');
    const boxInput = this.options.querySelector('[data-purchase-unit="box"]');
    const label = this.options.querySelector('[data-box-label]');
    const message = this.options.querySelector('[data-box-message]');
    const boxQuantity = Number(current?.boxQuantity || 0);
    const inventoryElement = this.form.closest('.shopify-section')?.querySelector('product-inventory');
    const renderedInventoryValue = inventoryElement?.dataset.inventoryQuantity;
    const renderedInventory = Number(renderedInventoryValue);
    const inventoryQuantity = Number.isFinite(renderedInventory) && renderedInventoryValue !== ''
      ? renderedInventory
      : Number(current?.inventoryQuantity || 0);
    const inventoryKnown = (renderedInventoryValue !== '' && Number.isFinite(renderedInventory)) || current?.inventoryQuantity != null;
    const inventoryManagement = inventoryElement?.dataset.inventoryManagement || current?.inventoryManagement;
    const inventoryPolicy = inventoryElement?.dataset.inventoryPolicy || current?.inventoryPolicy;
    const variantPicker = this.form.closest('.shopify-section')?.querySelector('[data-box-eligible-types]');
    const eligibleTypes = (variantPicker?.dataset.boxEligibleTypes || 'wholesale, master_distributor')
      .split(',').map((value) => value.trim().toLowerCase()).filter(Boolean);
    const b2bType = (this.form.dataset.b2bType || '').trim().toLowerCase();
    const trackedAndDenied = inventoryManagement === 'shopify' && inventoryPolicy === 'deny';
    const maxBoxes = trackedAndDenied && inventoryKnown && boxQuantity > 1 ? Math.floor(inventoryQuantity / boxQuantity) : null;
    const eligible = eligibleTypes.includes(b2bType) && boxQuantity > 1 && current?.available !== false && (maxBoxes === null || maxBoxes >= 1);

    this.dataset.inventoryCount = inventoryKnown ? String(inventoryQuantity) : '';
    this.hidden = !eligible;
    const priceElement = this.form.closest('.shopify-section')?.querySelector('product-price .price');
    if (priceElement && (current?.price != null || this.currentPrice > 0)) {
      const currency = window.Shopify?.currency?.active || 'AUD';
      priceElement.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(((current?.price != null ? Number(current.price) : this.currentPrice) * (boxInput.checked ? boxQuantity : 1)) / 100);
    }

    if (!eligible) {
      boxInput.checked = false;
      this.options.querySelector('[data-purchase-unit="single"]').checked = true;
    }
    const shouldShow = eligibleTypes.includes(b2bType) && boxQuantity > 1;
    console.info('[Box Purchase] eligibility check', {
      b2bTypeFromLocationMetafield: b2bType || '(blank)',
      eligibleTypes,
      variantId: variantIdInput?.value || '(blank)',
      variantFound: Boolean(current),
      boxQuantity,
      inventoryCount: inventoryKnown ? inventoryQuantity : '(unknown)',
      inventorySource: renderedInventoryValue !== '' ? 'product-inventory element' : 'variant JSON/fallback',
      inventoryManagement,
      inventoryPolicy,
      maxBoxes,
      variantAvailable: current?.available,
      eligible,
      shouldShow,
    });
    this.options.hidden = !shouldShow;
    boxOption.hidden = !shouldShow;
    boxInput.disabled = !eligible;
    label.textContent = label.dataset.labelTemplate.replace('{{ count }}', boxQuantity);
    boxInput.dataset.boxQuantity = String(boxQuantity);
    message.hidden = eligible || !shouldShow;
    this.input.max = this.options.querySelector('[data-purchase-unit="box"]').checked && maxBoxes !== null ? maxBoxes : (current?.quantityRule?.max || '');
  }
}

if (!customElements.get('box-purchase-option')) customElements.define('box-purchase-option', BoxPurchaseOption);
